import { AnalyticsEvent } from 'shared/constants/analytics';
import { HomeRoutePath } from 'shared/constants/router';

import { SidebarTypes } from './types';

import type { NavigationItemType } from './types';

export const OPENED_CONTENT_WIDTH = 216;
export const CLOSED_CONTENT_WIDTH = 46;
export const OPENED_DRAWER_WIDTH = 248;
export const CLOSED_DRAWER_WIDTH = 64;
export const SCHOOL_LOGO_MAX_HEIGHT = 72;

export const NAVIGATION_ANALYTICS_EVENT: Record<string, AnalyticsEvent> = {
  [HomeRoutePath.Dashboard]: AnalyticsEvent.SidebarDashboardButtonClicked,
  [HomeRoutePath.Subjects]: AnalyticsEvent.SidebarSubjectsButtonClicked,
  [HomeRoutePath.Progress]: AnalyticsEvent.SidebarProgressButtonClicked,
  [HomeRoutePath.Library]: AnalyticsEvent.SidebarLibraryButtonClicked,
  [HomeRoutePath.Reports]: AnalyticsEvent.SidebarReportsButtonClicked,
  [HomeRoutePath.Calendar]: AnalyticsEvent.SidebarCalendarButtonClicked,
  [HomeRoutePath.ParentHelper]: AnalyticsEvent.AIParentHelperChatbotTabClicked,
};

export const NAVIGATION_ITEM_VARIANT_MAP: Record<
  SidebarTypes,
  NavigationItemType
> = {
  [SidebarTypes.DEFAULT]: 'primary',
  [SidebarTypes.ADMIN]: 'secondary',
};
